export const translation = {
  zenit: {
    ae: {
      siteTitle: 'راهن وفز بمكافأة!',
      btnHeaderLogin: 'سجّل الدخول',
      btnHeaderSignup: 'سجل الآن',
      btnHeaderLine: 'رياضات',
      btnHeaderLive: 'LIVE',
      sumFor: ' للعملاء الجدد!',
      title: `ضع رهانًا واحصل على`,
      titleSpan: 'مكافأة!',
      btnSignup: 'سجل',
      btnLogin: 'سجّل الدخول',
      btnGet: 'احصل على',
      popularTitle: 'مكافأتك هي:',
      outputTitle: 'إيداع',
      regText: 'سجل واحصل على مكافأتك!',
      bkString: 'لمراهنات Zenit',
      rightString: 'جميع الحقوق محفوظة',
      rulesBtn: 'الشروط والأحكام',
    },
    bn: {
      siteTitle: 'বাজি ধরুন এবং বোনাস পান!',
      btnHeaderLogin: 'লগইন',
      btnHeaderSignup: 'নিবন্ধন করুন',
      btnHeaderLine: 'স্পোর্টস',
      btnHeaderLive: 'LIVE',
      sumFor: 'নতুন গ্রাহকদের জন্য!',
      title: `বাজি ধরুন এবং`,
      titleSpan: 'বোনাস পান!',
      btnSignup: 'নিবন্ধন করুন',
      btnLogin: 'লগইন',
      btnGet: 'পান',
      popularTitle: 'আপনার বোনাস হল:',
      outputTitle: 'জমা করুন',
      regText: 'সাইন আপ করুন এবং আপনার বোনাস নিয়ে যান!',
      bkString: 'বুকমেকার Zenit',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
      rulesBtn: 'শর্তাবলী',
    },
    br: {
      siteTitle: 'Faça uma aposta e ganhe um bônus!',
      btnHeaderLogin: 'LOGIN',
      btnHeaderSignup: 'REGISTRE-SE',
      btnHeaderLine: 'ESPORTES',
      btnHeaderLive: 'LIVE',
      sumFor: 'para novos clientes!',
      title: `FAÇA UMA APOSTA
        E GANHE UM`,
      titleSpan: 'BÔNUS!',
      btnSignup: 'REGISTRE-SE',
      btnLogin: 'LOGIN',
      btnGet: 'Obter bônus',
      popularTitle: 'SEU BÔNUS É:',
      outputTitle: 'Depósito',
      regText: 'INSCREVA-SE E LEVE O BÔNUS PARA CASA!',
      bkString: 'Casa de Apostas Zenit',
      rightString: 'Todos os direitos reservados',
      rulesBtn: 'TERMOS E CONDIÇÕES',
    },
    de: {
      siteTitle: 'Wette abschließen und einen Bonus erhalten!',
      btnHeaderLogin: 'ANMELDEN',
      btnHeaderSignup: 'REGISTRIEREN',
      btnHeaderLine: 'Sportarten',
      btnHeaderLive: 'LIVE',
      sumFor: 'für Neukunden!',
      title: `WETTE ABSCHLIESSEN 
        UND`,
      titleSpan: 'BONUS ERHALTEN!',
      btnSignup: 'JETZT ANMELDEN',
      btnLogin: 'ANMELDEN',
      btnGet: 'ERHALTEN',
      popularTitle: 'IHR BONUS BETRÄGT:',
      outputTitle: 'Einzahlung',
      regText: 'ANMELDEN UND BONUS MIT NACH HAUSE NEHMEN!',
      bkString: 'Buchmacher Zenit',
      rightString: 'Alle Rechte vorbehalten',
      rulesBtn: 'Regeln',
    },
    en: {
      siteTitle: 'Make a bet and get a bonus!',
      btnHeaderLogin: 'Login',
      btnHeaderSignup: 'Sign up',
      btnHeaderLine: 'SPORTS',
      btnHeaderLive: 'LIVE',
      sumFor: 'to new customers!',
      title: `PLACE A BET AND
        GET A`,
      titleSpan: 'BONUS!',
      btnSignup: 'SIGN UP',
      btnLogin: 'LOGIN',
      btnGet: 'GET',
      popularTitle: 'YOUR BONUS IS:',
      outputTitle: 'Deposit',
      regText: 'SIGN UP AND TAKE YOUR BONUS HOME!',
      bkString: 'Bookmaker Zenit',
      rightString: 'All rights reserved',
      rulesBtn: 'TERMS AND CONDITIONS',
    },
    fr: {
      siteTitle: 'Faites un pari et obtenez un bonus!',
      btnHeaderLogin: 'Connexion',
      btnHeaderSignup: `S'ENREGISTRER`,
      btnHeaderLine: 'SPORTS',
      btnHeaderLive: 'LIVE',
      sumFor: 'pour les nouveaux clients!',
      title: `PLACEZ UN PARI POUR OBTENIR UN`,
      titleSpan: 'BONUS!',
      btnSignup: `S'enregistrer`,
      btnLogin: 'Connexion',
      btnGet: 'OBTENEZ',
      popularTitle: 'VOTRE BONUS EST:',
      outputTitle: 'Dépôt',
      regText: 'INSCRIVEZ-VOUS POUR EMPOCHER VOTRE BONUS!',
      bkString: 'Bookmaker Zenit',
      rightString: 'Tous droits réservés',
      rulesBtn: 'Conditions générales',
    },
    ir: {
      siteTitle: 'پاداش‌های متنوع برای مشتریان جدید | شرط‌بندی | ZENIT',
      btnHeaderLogin: 'لاگین',
      btnHeaderSignup: 'ثبت‌نام کنید',
      btnHeaderLine: 'ورزش‌ها',
      btnHeaderLive: 'LIVE',
      sumFor: 'برای بازیکنان جدید!',
      title: `شرط ببندید و پاداش دریافت کنید!`,
      titleSpan: '',
      btnSignup: 'ثبت‌نام کنید',
      btnLogin: 'لاگین',
      btnGet: 'پاداش دریافت کنید',
      popularTitle: 'جایزه شما:',
      outputTitle:'واریز',
      regText: 'ثبت‌نام کرده و جایزه‌تان را دریافت کنید!',
      bkString: 'بنگاه شرط‌بندی Zenit',
      rightString: 'تمامی حقوق محفوظ است',
      rulesBtn: 'شرایط و ضوابط',
    },
    kz: {
      siteTitle: 'Бонусты бастау | Онлайн ставкалар | ZENIT',
      btnHeaderLogin: 'КІРУ',
      btnHeaderSignup: 'ТІРКЕЛУ',
      btnHeaderLine: 'ТІЗБЕК',
      btnHeaderLive: 'LIVE',
      sumFor: 'Жаңа ойыншыларға',
      sumFor2: 'беріледі!',
      title: 'БӘС ТІК ТЕ',
      titleSpan: 'БОНУСЫҢДЫ',
      title2: 'АЛ!',
      btnSignup: 'Тіркел',
      btnLogin: 'Кіру',
      btnGet: 'Ал',
      popularTitle: 'БОНУС СОМАСЫ:',
      outputTitle: 'Толықтыру',
      regText: 'ТІРКЕЛ ДЕ, БОНУС АЛ!',
      bkString: 'Зенит букмекерлік кеңесі',
      rightString: 'Барлық құқығы қорғалған',
      rulesBtn: 'ЕРЕЖЕЛЕР',
    },
    mx: {
      siteTitle: '¡Haga una apuesta y obtenga una bonificación!',
      btnHeaderLogin: 'LOGIN',
      btnHeaderSignup: 'REGÍSTRESE',
      btnHeaderLine: 'Deportes',
      btnHeaderLive: 'LIVE',
      sumFor: 'para los nuevos clientes',
      title: `¡HAGA UNA APUESTA
        Y OBTENGA UNA`,
      titleSpan: ' BONIFICACIÓN!',
      btnSignup: 'REGÍSTRESE',
      btnLogin: 'LOGIN',
      btnGet: 'LLÉVESE',
      popularTitle: 'SU BONIFICACIÓN ES:',
      outputTitle: 'Depósito',
      regText: '¡REGÍSTRESE Y LLÉVESE LA BONIFICACIÓN A CASA!',
      bkString: 'Bookmaker Zenit',
      rightString: 'Todos los derechos reservados',
      rulesBtn: 'TÉRMINOS Y CONDICIONES',
    },
    ru: {
      siteTitle: 'Стартовый бонус | Ставки на спорт | ZENIT',
      btnHeaderLogin: 'Вход',
      btnHeaderSignup: 'Регистрация',
      btnHeaderLine: 'ЛИНИЯ',
      btnHeaderLive: 'LIVE',
      sumFor: 'новым игрокам!',
      title: `СДЕЛАЙ СТАВКУ И
        ПОЛУЧИ СВОЙ`,
      titleSpan: 'БОНУС!',
      btnSignup: 'РЕГИСТРИРУЙСЯ',
      btnLogin: 'ВХОД',
      btnGet: 'ПОЛУЧИ',
      popularTitle: 'СУММА ТВОЕГО БОНУСА:',
      outputTitle: 'Пополнение',
      regText: 'Зарегистрируйся и получи бонус!',
      bkString: 'Букмекерская контора «Зенит»',
      rightString: 'Все права защищены',
      rulesBtn: 'правила',
    },
    sw: {
      siteTitle: 'Wekeza dau na upokee bonasi!',
      btnHeaderLogin: 'Ingia',
      btnHeaderSignup: 'JISAJILI',
      btnHeaderLine: 'Michezo',
      btnHeaderLive: 'LIVE',
      sumFor: 'kwa wateja wapya!',
      title: `WEKEZA DAU 
        NA UPOKEE`,
      titleSpan: 'BONASI!',
      btnSignup: 'JISAJILI',
      btnLogin: 'Ingia',
      btnGet: 'PATA',
      popularTitle: 'BONASI YAKO NI:',
      outputTitle: 'Kuweka pesa',
      regText: 'JISAJILI NA UPOKEE BONASI!',
      bkString: 'Alamisho Zenit',
      rightString: 'Haki zote zimehifadhiwa',
      rulesBtn: 'SHERIA NA\xA0MASHARTI',
    },
    tr: {
      siteTitle: 'Bir bahis oynayın ve bir bonus kazanın!',
      btnHeaderLogin: 'Giriş',
      btnHeaderSignup: 'KAYDOLUN',
      btnHeaderLine: 'Spor',
      btnHeaderLive: 'LIVE',
      sumFor: 'Yeni müşterilere!',
      title: `BİR BAHİS
        OYNAYIN VE BİR`,
      titleSpan: 'BONUS KAZANIN!',
      btnSignup: 'KAYDOLUN',
      btnLogin: 'Giriş',
      btnGet: 'AL',
      popularTitle: 'BONUSUNUZ:',
      outputTitle: 'Para yatırma',
      regText: 'KAYDOLUN VE BONUSUNUZU ALIP GİDİN!',
      bkString: 'Zenit Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
      rulesBtn: 'HÜKÜM VE KOŞULLAR',
    },
    ua: {
      siteTitle: 'Бонус новым игрокам | Ставки | ZENIT',
      btnHeaderLogin: 'Вход',
      btnHeaderSignup: 'Регистрация',
      btnHeaderLine: 'ЛИНИЯ',
      btnHeaderLive: 'LIVE',
      sumFor: 'новым игрокам!',
      title: `СДЕЛАЙ СТАВКУ И
        ПОЛУЧИ СВОЙ`,
      titleSpan: 'БОНУС!',
      btnSignup: 'РЕГИСТРИРУЙСЯ',
      btnLogin: 'ВХОД',
      btnGet: 'ПОЛУЧИ',
      popularTitle: 'СУММА ТВОЕГО БОНУСА:',
      outputTitle: 'Пополнение',
      regText: 'Зарегистрируйся и получи бонус!',
      bkString: 'Букмекерская контора Зенит',
      rightString: 'Все права защищены',
      rulesBtn: 'правила',
    },
    uz: {
      siteTitle: 'Stavka qil - o‘z bonusingni ol',
      btnHeaderLogin: 'Kirish',
      btnHeaderSignup: 'RO‘YXATDAN O‘TISH',
      btnHeaderLine: 'Liniya',
      btnHeaderLive: 'LIVE',
      sumFor: 'Yangi o‘yinchilarga!',
      title: `STAVKA QIL
        VA O‘Z`,
      titleSpan: 'BONUSINGNI OL!',
      btnSignup: 'Ro‘yxatdan o‘t!',
      btnLogin: 'Kirish',
      btnGet: 'OLISH',
      popularTitle: 'BONUSING SUMMASI:',
      outputTitle: 'To‘ldirish',
      regText: 'RO‘YXATDAN O‘T VA BONUS OL!',
      bkString: 'Zenit bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
      rulesBtn: 'QOIDALAR',
    },
    vi: {
      siteTitle: 'Đặt cược và nhận tiền thưởng!',
      btnHeaderLogin: 'Đăng nhập',
      btnHeaderSignup: 'Đăng ký ngay',
      btnHeaderLine: 'Môn thể thao',
      btnHeaderLive: 'LIVE',
      sumFor: 'cho khách hàng mới!',
      title: `ĐẶT CƯỢC
        VÀ NHẬN`,
      titleSpan: 'TIỀN THƯỞNG!',
      btnSignup: 'ĐĂNG KÝ',
      btnLogin: 'Đăng nhập',
      btnGet: 'NHẬN',
      popularTitle: 'TIỀN THƯỞNG CỦA BẠN LÀ:',
      outputTitle: 'Nạp tiền',
      regText: 'ĐĂNG KÝ VÀ NHẬN TIỀN THƯỞNG CỦA BẠN!',
      bkString: 'Nhà cái Zenit',
      rightString: 'Bảo lưu mọi quyền',
      rulesBtn: 'Điều khoản và\xA0điều\xA0kiện',
    },
  },
  zenbet: {
    ae: {
      siteTitle: 'راهن وفز بمكافأة!',
      btnHeaderLogin: 'سجّل الدخول',
      btnHeaderSignup: 'سجل الآن',
      btnHeaderLine: 'رياضات',
      btnHeaderLive: 'LIVE',
      sumFor: ' للعملاء الجدد!',
      title: `ضع رهانًا واحصل على`,
      titleSpan: 'مكافأة!',
      btnSignup: 'سجل',
      btnLogin: 'سجّل الدخول',
      btnGet: 'احصل على',
      popularTitle: 'مكافأتك هي:',
      outputTitle: 'إيداع',
      regText: 'سجل واحصل على مكافأتك!',
      bkString: 'لمراهنات «ZENBET»',
      rightString: 'جميع الحقوق محفوظة',
      rulesBtn: 'الشروط والأحكام',
    },
    bn: {
      siteTitle: 'বাজি ধরুন এবং বোনাস পান!',
      btnHeaderLogin: 'লগইন',
      btnHeaderSignup: 'নিবন্ধন করুন',
      btnHeaderLine: 'স্পোর্টস',
      btnHeaderLive: 'LIVE',
      sumFor: 'নতুন গ্রাহকদের জন্য!',
      title: `বাজি ধরুন এবং`,
      titleSpan: 'বোনাস পান!',
      btnSignup: 'নিবন্ধন করুন',
      btnLogin: 'লগইন',
      btnGet: 'পান',
      popularTitle: 'আপনার বোনাস হল:',
      outputTitle: 'জমা করুন',
      regText: 'সাইন আপ করুন এবং আপনার বোনাস নিয়ে যান!',
      bkString: 'বুকমেকার «ZENBET»',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
      rulesBtn: 'শর্তাবলী',
    },
    br: {
      siteTitle: 'Bônus para novos clientes | Apostas | «ZENBET»',
      btnHeaderLogin: 'LOGIN',
      btnHeaderSignup: 'REGISTRE-SE',
      btnHeaderLine: 'ESPORTES',
      btnHeaderLive: 'LIVE',
      sumFor: 'para novos clientes!',
      title: `FAÇA UMA APOSTA
        E GANHE UM`,
      titleSpan: 'BÔNUS!',
      btnSignup: 'REGISTRE-SE',
      btnLogin: 'LOGIN',
      btnGet: 'Obter bônus',
      popularTitle: 'SEU BÔNUS É:',
      outputTitle: 'Depósito',
      regText: 'INSCREVA-SE E LEVE O BÔNUS PARA CASA!',
      bkString: 'Casa de Apostas «ZENBET»',
      rightString: 'Todos os direitos reservados',
      rulesBtn: 'TERMOS E CONDIÇÕES',
    },
    de: {
      siteTitle: 'Wette abschließen und einen Bonus erhalten!',
      btnHeaderLogin: 'ANMELDEN',
      btnHeaderSignup: 'REGISTRIEREN',
      btnHeaderLine: 'Sportarten',
      btnHeaderLive: 'LIVE',
      sumFor: 'für Neukunden!',
      title: `WETTE ABSCHLIESSEN 
        UND`,
      titleSpan: 'BONUS ERHALTEN!',
      btnSignup: 'JETZT ANMELDEN',
      btnLogin: 'ANMELDEN',
      btnGet: 'ERHALTEN',
      popularTitle: 'IHR BONUS BETRÄGT:',
      outputTitle: 'Einzahlung',
      regText: 'ANMELDEN UND BONUS MIT NACH HAUSE NEHMEN!',
      bkString: 'Buchmacher «ZENBET»',
      rightString: 'Alle Rechte vorbehalten',
      rulesBtn: 'Regeln',
    },
    en: {
      siteTitle: 'Bonuses to new customers | Betting | «ZENBET»',
      btnHeaderLogin: 'Login',
      btnHeaderSignup: 'Sign up',
      btnHeaderLine: 'SPORTS',
      btnHeaderLive: 'LIVE',
      sumFor: 'to new customers!',
      title: `PLACE A BET AND
        GET A`,
      titleSpan: 'BONUS!',
      btnSignup: 'SIGN UP',
      btnLogin: 'LOGIN',
      btnGet: 'GET',
      popularTitle: 'YOUR BONUS IS:',
      outputTitle: 'Deposit',
      regText: 'SIGN UP AND TAKE YOUR BONUS HOME!',
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'All rights reserved',
      rulesBtn: 'TERMS AND CONDITIONS',
    },
    fr: {
      siteTitle: 'Faites un pari et obtenez un bonus!',
      btnHeaderLogin: 'Connexion',
      btnHeaderSignup: `S'ENREGISTRER`,
      btnHeaderLine: 'SPORTS',
      btnHeaderLive: 'LIVE',
      sumFor: 'pour les nouveaux clients!',
      title: `PLACEZ UN PARI POUR OBTENIR UN`,
      titleSpan: 'BONUS!',
      btnSignup: `S'enregistrer`,
      btnLogin: 'Connexion',
      btnGet: 'OBTENEZ',
      popularTitle: 'VOTRE BONUS EST:',
      outputTitle: 'Dépôt',
      regText: 'INSCRIVEZ-VOUS POUR EMPOCHER VOTRE BONUS!',
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'Tous droits réservés',
      rulesBtn: 'Conditions générales',
    },
    ir: {
      siteTitle: 'پاداش‌های متنوع برای مشتریان جدید | شرط‌بندی | «ZENBET»',
      btnHeaderLogin: 'لاگین',
      btnHeaderSignup: 'ثبت‌نام کنید',
      btnHeaderLine: 'ورزش‌ها',
      btnHeaderLive: 'LIVE',
      sumFor: 'برای بازیکنان جدید!',
      title: `شرط ببندید و پاداش دریافت کنید!`,
      titleSpan: '',
      btnSignup: 'ثبت‌نام کنید',
      btnLogin: 'لاگین',
      btnGet: 'پاداش دریافت کنید',
      popularTitle: 'جایزه شما:',
      outputTitle:'واریز',
      regText: 'ثبت‌نام کرده و جایزه‌تان را دریافت کنید!',
      bkString: 'بنگاه شرط‌بندی «ZENBET»',
      rightString: 'تمامی حقوق محفوظ است',
      rulesBtn: 'شرایط و ضوابط',
    },
    kz: {
      siteTitle: 'Ұтыс тігіп, өз бонусыңды ал!',
      btnHeaderLogin: 'КІРУ',
      btnHeaderSignup: 'ТІРКЕЛУ',
      btnHeaderLine: 'ТІЗБЕК',
      btnHeaderLive: 'LIVE',
      sumFor: 'Жаңа ойыншыларға',
      sumFor2: 'беріледі!',
      title: 'БӘС ТІК ТЕ',
      titleSpan: 'БОНУСЫҢДЫ',
      title2: 'АЛ!',
      btnSignup: 'Тіркел',
      btnLogin: 'Кіру',
      btnGet: 'Ал',
      popularTitle: 'БОНУС СОМАСЫ:',
      outputTitle: 'Толықтыру',
      regText: 'ТІРКЕЛ ДЕ, БОНУС АЛ!',
      bkString: '«ZENBET» букмекерлік кеңесі',
      rightString: 'Барлық құқығы қорғалған',
      rulesBtn: 'ЕРЕЖЕЛЕР',
    },
    mx: {
      siteTitle: '¡Haga una apuesta y obtenga una bonificación!',
      btnHeaderLogin: 'LOGIN',
      btnHeaderSignup: 'REGÍSTRESE',
      btnHeaderLine: 'Deportes',
      btnHeaderLive: 'LIVE',
      sumFor: 'para los nuevos clientes',
      title: `¡HAGA UNA APUESTA
        Y OBTENGA UNA`,
      titleSpan: ' BONIFICACIÓN!',
      btnSignup: 'REGÍSTRESE',
      btnLogin: 'LOGIN',
      btnGet: 'LLÉVESE',
      popularTitle: 'SU BONIFICACIÓN ES:',
      outputTitle: 'Depósito',
      regText: '¡REGÍSTRESE Y LLÉVESE LA BONIFICACIÓN A CASA!',
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'Todos los derechos reservados',
      rulesBtn: 'TÉRMINOS Y CONDICIONES',
    },
    ru: {
      siteTitle: 'Сделай ставку - забирай свой бонус',
      btnHeaderLogin: 'Вход',
      btnHeaderSignup: 'Регистрация',
      btnHeaderLine: 'ЛИНИЯ',
      btnHeaderLive: 'LIVE',
      sumFor: 'новым игрокам!',
      title: `СДЕЛАЙ СТАВКУ И
        ПОЛУЧИ СВОЙ`,
      titleSpan: 'БОНУС!',
      btnSignup: 'РЕГИСТРИРУЙСЯ',
      btnLogin: 'ВХОД',
      btnGet: 'ПОЛУЧИ',
      popularTitle: 'СУММА ТВОЕГО БОНУСА:',
      outputTitle: 'Пополнение',
      regText: 'Зарегистрируйся и получи бонус!',
      bkString: 'Букмекерская контора «ZENBET»',
      rightString: 'Все права защищены',
      rulesBtn: 'правила',
    },
    sw: {
      siteTitle: 'Wekeza dau na upokee bonasi!',
      btnHeaderLogin: 'Ingia',
      btnHeaderSignup: 'JISAJILI',
      btnHeaderLine: 'Michezo',
      btnHeaderLive: 'LIVE',
      sumFor: 'kwa wateja wapya!',
      title: `WEKEZA DAU 
        NA UPOKEE`,
      titleSpan: 'BONASI!',
      btnSignup: 'JISAJILI',
      btnLogin: 'Ingia',
      btnGet: 'PATA',
      popularTitle: 'BONASI YAKO NI:',
      outputTitle: 'Kuweka pesa',
      regText: 'JISAJILI NA UPOKEE BONASI!',
      bkString: 'Alamisho «ZENBET»',
      rightString: 'Haki zote zimehifadhiwa',
      rulesBtn: 'SHERIA NA\xA0MASHARTI',
    },
    tr: {
      siteTitle: 'Bir bahis oynayın ve bir bonus kazanın!',
      btnHeaderLogin: 'Giriş',
      btnHeaderSignup: 'KAYDOLUN',
      btnHeaderLine: 'Spor',
      btnHeaderLive: 'LIVE',
      sumFor: 'Yeni müşterilere!',
      title: `BİR BAHİS
        OYNAYIN VE BİR`,
      titleSpan: 'BONUS KAZANIN!',
      btnSignup: 'KAYDOLUN',
      btnLogin: 'Giriş',
      btnGet: 'AL',
      popularTitle: 'BONUSUNUZ:',
      outputTitle: 'Para yatırma',
      regText: 'KAYDOLUN VE BONUSUNUZU ALIP GİDİN!',
      bkString: '«ZENBET» Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
      rulesBtn: 'HÜKÜM VE KOŞULLAR',
    },
    uz: {
      siteTitle: 'Stavka qil - o‘z bonusingni ol',
      btnHeaderLogin: 'Kirish',
      btnHeaderSignup: 'RO‘YXATDAN O‘TISH',
      btnHeaderLine: 'Liniya',
      btnHeaderLive: 'LIVE',
      sumFor: 'Yangi o‘yinchilarga!',
      title: `STAVKA QIL
        VA O‘Z`,
      titleSpan: 'BONUSINGNI OL!',
      btnSignup: 'Ro‘yxatdan o‘t!',
      btnLogin: 'Kirish',
      btnGet: 'OLISH',
      popularTitle: 'BONUSING SUMMASI:',
      outputTitle: 'To‘ldirish',
      regText: 'RO‘YXATDAN O‘T VA BONUS OL!',
      bkString: '«ZENBET» bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
      rulesBtn: 'QOIDALAR',
    },
    vi: {
      siteTitle: 'Đặt cược và nhận tiền thưởng!',
      btnHeaderLogin: 'Đăng nhập',
      btnHeaderSignup: 'Đăng ký ngay',
      btnHeaderLine: 'Môn thể thao',
      btnHeaderLive: 'LIVE',
      sumFor: 'cho khách hàng mới!',
      title: `ĐẶT CƯỢC
        VÀ NHẬN`,
      titleSpan: 'TIỀN THƯỞNG!',
      btnSignup: 'ĐĂNG KÝ',
      btnLogin: 'Đăng nhập',
      btnGet: 'NHẬN',
      popularTitle: 'TIỀN THƯỞNG CỦA BẠN LÀ:',
      outputTitle: 'Nạp tiền',
      regText: 'ĐĂNG KÝ VÀ NHẬN TIỀN THƯỞNG CỦA BẠN!',
      bkString: 'Nhà cái «ZENBET»',
      rightString: 'Bảo lưu mọi quyền',
      rulesBtn: 'Điều khoản và\xA0điều\xA0kiện',
    },
  }
}